<template>
	<div class="chart-pie-wrapper">
		<canvas ref="chart" :style="{'height': height + 'px'}"></canvas>
	</div>
</template>

<script>
	import { Chart, registerables } from 'chart.js';
	Chart.register(...registerables);

	export default ({
		props: [
			'data',
			'height',
			'title'
		],
		data(){
			return {
				chart: null,
				resizeObserver: null,
			} ;
		},
		mounted () { 
    		let ctx = this.$refs.chart.getContext("2d");
			this.chart = new Chart(ctx, {
				type: "doughnut",
				data: this.data,
     			options: {
					layout: {
						padding: {
							top: 5,
							right: 5,
							left: 5,
							bottom: 5,
						},
					},
					responsive: true,
					maintainAspectRatio: false,
					resizeDelay: 0,
					plugins: {
						legend: {
							display: true,
							position: 'bottom',
							align: 'center',
							labels: {
								font: {
									size: 10,
								},
								padding: 8,
								usePointStyle: true,
								pointStyle: 'circle',
								boxWidth: 6,
								boxHeight: 6,
								generateLabels: function(chart) {
									const data = chart.data;
									if (data.labels.length && data.datasets.length) {
										return data.labels.map((label, i) => {
											const dataset = data.datasets[0];
											const backgroundColor = dataset.backgroundColor[i];
											return {
												text: label,
												fillStyle: backgroundColor,
												strokeStyle: backgroundColor,
												lineWidth: 0,
												pointStyle: 'circle'
											};
										});
									}
									return [];
								}
							},
						},
						title: {
							display: false,
							text: this.title,
							font: {
								size: 12,
							},
							position: 'bottom',
						},
						
					},
					tooltips: {
						enabled: true,
						mode: "index",
						intersect: false,
					},
					spacing: 2,
				}
			});

			// Configurar ResizeObserver para detectar cambios de tamaño
			this.setupResizeObserver();
			
			// Forzar un resize inicial después de un pequeño delay
			this.$nextTick(() => {
				setTimeout(() => {
					if (this.chart) {
						this.chart.resize();
					}
				}, 100);
			});
		},

		watch: {
			data: {
				handler(newData) {
					if (this.chart && newData) {
						this.chart.data = newData;
						this.chart.update('resize');
						this.$nextTick(() => {
							this.chart.resize();
						});
					}
				},
				deep: true
			}
		},

		methods: {
			setupResizeObserver() {
				if (window.ResizeObserver && this.$refs.chart) {
					this.resizeObserver = new ResizeObserver(() => {
						if (this.chart) {
							// Usar requestAnimationFrame para evitar múltiples llamadas
							requestAnimationFrame(() => {
								if (this.chart) {
									this.chart.resize();
								}
							});
						}
					});
					this.resizeObserver.observe(this.$refs.chart.parentElement);
				}
			},

			handleResize() {
				if (this.chart) {
					this.chart.resize();
				}
			}
		},

		// Right before the component is destroyed,
		// also destroy the chart.
		beforeDestroy: function () {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
			if (this.chart) {
				this.chart.destroy();
			}
		},
	})

</script>

<style lang="scss" scoped>
.chart-pie-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    min-height: 200px;
    padding: 0.25rem;
    position: relative;
}

.chart-pie-wrapper canvas {
    margin: 0 auto !important;
    display: block !important;
    max-width: 100% !important;
    max-height: 100% !important;
    width: auto !important;
    height: auto !important;
}
</style>